import React from "react";
import { Link, NavLink, Outlet, Navigate } from "react-router-dom";
import { LayoutDashboard, FileText, Users, Sparkles, LogOut, ExternalLink } from "lucide-react";
import { useAuth } from "../../context/AuthContext";

const NAV = [
  { to: "/admin", end: true, label: "Tableau de bord", icon: LayoutDashboard },
  { to: "/admin/blog", label: "Articles", icon: FileText },
  { to: "/admin/staff", label: "Professionnels", icon: Users },
  { to: "/admin/services", label: "Services", icon: Sparkles },
];

export default function AdminLayout() {
  const { admin, logout } = useAuth();

  if (admin === null) {
    return <div className="min-h-screen flex items-center justify-center text-slate-500">Chargement...</div>;
  }
  if (admin === false) return <Navigate to="/admin/login" replace />;

  return (
    <div className="min-h-screen bg-slate-50 font-jakarta flex">
      <aside className="w-64 bg-white border-r border-slate-100 flex flex-col fixed inset-y-0 left-0">
        <div className="p-6 border-b border-slate-100">
          <Link to="/admin" className="flex items-center gap-3">
            <img src="/images/symbol.png" alt="Psymed" className="w-10 h-10" />
            <div>
              <p className="font-outfit font-bold text-slate-900 text-sm">Psymed Admin</p>
              <p className="text-xs text-slate-400">{admin.email}</p>
            </div>
          </Link>
        </div>
        <nav className="flex-1 p-4 space-y-1">
          {NAV.map(({ to, end, label, icon: Icon }) => (
            <NavLink
              key={to}
              to={to}
              end={end}
              className={({ isActive }) =>
                `flex items-center gap-3 px-4 py-2.5 rounded-2xl text-sm font-medium transition-colors ${
                  isActive ? "bg-blue-50 text-[#2E4DB5]" : "text-slate-600 hover:bg-slate-50"
                }`
              }
              data-testid={`nav-${to.replace("/admin", "") || "dashboard"}`}
            >
              <Icon className="w-4 h-4" />
              {label}
            </NavLink>
          ))}
        </nav>
        <div className="p-4 border-t border-slate-100 space-y-2">
          <a
            href="/"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-3 px-4 py-2 text-xs text-slate-500 hover:text-slate-800"
          >
            <ExternalLink className="w-3.5 h-3.5" /> Voir le site
          </a>
          <button
            onClick={logout}
            className="w-full flex items-center gap-3 px-4 py-2.5 rounded-2xl text-sm font-medium text-rose-600 hover:bg-rose-50 transition-colors"
            data-testid="logout-btn"
          >
            <LogOut className="w-4 h-4" /> Déconnexion
          </button>
        </div>
      </aside>

      <main className="ml-64 flex-1 p-8 max-w-6xl">
        <Outlet />
      </main>
    </div>
  );
}
